import Vue from 'vue'
import i18n from './i18n'
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
    path: '/:locale',
    component: {
        template: "<router-view></router-view>"
    },
    beforeEnter: (to, from, next) => {
        console.log(to.params.locale);
        const locale = to.params.locale;
        const supported_locales = ["bg", "cn", "cz", "de", "dk", "ee", "en", "es", "fr", "gr", "hu", "is", "it", "ja", "lt", "lu", "lv", "nl", "no", "pl", "pt", "rs", "ru", "se", "sk", "tr", "ua", "vn"];
        if (!supported_locales.includes(locale)) {
            //fallback
            return next('en');
        }
        if (i18n.locale !== locale) {
            i18n.locale = locale;
        }
        return next()
    },
    children: [{
        path: '',
        name: 'Home',
        component: load('App')
    }]
}];

function load(component) {
    // '@' is aliased to src/components
    return () => import(`./${component}.vue`)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
export default router